import { PropsWithChildren, memo } from 'react';
import ReactDOM from 'react-dom';

type PortalProps = PropsWithChildren<{ targetElementId: string }>;

const _Portal = ({ children, targetElementId }: PortalProps) => {
  const container = document.getElementById(targetElementId);

  return container ? ReactDOM.createPortal(children, container) : null;
};

export const Portal = memo(_Portal);
